import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { PaginationType } from '../types/Pagination.types';
import type { CategoryListItemDto, CategoryListParams } from './categories.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { PUBLIC_QUERY_STALE_TIME } from '../queryOptions.helpers';
import { categoriesApi } from './categories.api';

const DEFAULT_CATEGORIES_PARAMS: CategoryListParams = {
  filters: { isActive: true },
  limit: 20,
};

export const queryCategories = (params?: CategoryListParams) => {
  const requestParams: CategoryListParams = {
    ...DEFAULT_CATEGORIES_PARAMS,
    ...params,
    filters: {
      ...(DEFAULT_CATEGORIES_PARAMS.filters ?? {}),
      ...(params?.filters ?? {}),
    },
  };

  return queryOptions({
    queryKey: [QueriesKeys.categories, requestParams],
    queryFn: () => categoriesApi.fetchAll(requestParams),
    staleTime: PUBLIC_QUERY_STALE_TIME,
  });
};

export const queryCategoryById = (id: string) => {
  return queryOptions({
    queryKey: [QueriesKeys.categories, id],
    queryFn: () => categoriesApi.fetchById(id),
    // Public storefront data is hydrated from SSR and should not refetch
    // on client mount/focus just because the user session state changed.
    staleTime: PUBLIC_QUERY_STALE_TIME,
  });
};

export const categoryQueryOptions = {
  /**
   * Fetch categories list
   */
  list: (params?: CategoryListParams, options?: QueryOptionsOverride<PaginationType<CategoryListItemDto>>) => queryOptions({
    queryKey: [QueriesKeys.categories, params],
    queryFn: () => categoriesApi.fetchAll(params),
    ...options,
  }),
  /**
   * Fetch category by Id
   */
  byId: (id: string) => queryOptions({
    queryKey: [QueriesKeys.categories, id],
    queryFn: () => categoriesApi.fetchById(id),
    staleTime: PUBLIC_QUERY_STALE_TIME,
  }),
};
